/**
 * One frame of `GET v1/hub/paper-trading/price/sse?pairs=…`: the single price
 * paper orders fill at. Carries no provider name by design.
 */
export type PaperPriceFrame = {
  /** Clean CCXT pair symbol, e.g. `"BTC/USDC:USDC"`. */
  pairSymbol: string;
  /**
   * Decimal string, or `null` once the last known price is older than
   * `PAPER_STALENESS_THRESHOLD_MS` — the same threshold the engine rejects
   * orders on. A client shows no live price for the pair rather than the last
   * frame it happens to hold. A pair that has never ticked is absent instead.
   */
  price: string | null;
  /** Price timestamp, epoch ms. */
  ts: number;
};
